<script lang="ts">
  import { Button, Heading, Wrapper } from './components';
  import { PricingCard } from './components/pricing';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;

  $: ({ background, borderRadius } = settings);

  const cardClasses = ['single', 'double', 'default'];
</script>

<Wrapper background={'var(--vlt-lp-background)'}>
  <div class="pricing-section">
    {#if properties?.heading}
      <Heading type="h2" css={'margin-bottom:40px;'}>
        {@html properties?.heading}
      </Heading>
    {/if}

    <div class="cards {cardClasses[properties?.items.length - 1]}">
      {#if properties?.items.length}
        {#each properties.items as card}
          <PricingCard
            {background}
            {card}
            billingType={properties?.billingType}
            priceType={properties?.priceType}
          />
        {/each}
      {/if}
    </div>
  </div>

  {#if properties?.button?.active}
    <div class="button">
      <Button
        {borderRadius}
        section="pricing"
        buttonType={properties.button.link_type}
        buttonLink={properties.button.link}
        buttonTitle={properties.button.label}
      />
    </div>
  {/if}
</Wrapper>

<style>
  .pricing-section {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 15px;
  }
  .cards {
    width: 100%;
    max-width: 1300px;
    display: grid;
    gap: 28px;
    justify-content: center;
    grid-template-columns: repeat(auto-fit, minmax(300px, 360px));
  }
  .button {
    margin-top: 40px;
    width: 100%;
    display: flex;
    justify-content: center;
    font-family: var(--vlt-lp-paragraph-font, 'DM Sans');
  }
  .cards.default {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }

  @media screen and (max-width: 800px) {
    .cards.double {
      gap: 20px;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    }
  }

  @media screen and (max-width: 640px) {
    .cards {
      gap: 20px;
      grid-template-columns: 1fr;
    }
  }
</style>
